import BaseService from "./BaseService";
import { API_BASE_URL_ENV } from "../jsx/common/common";

const apiEndpoint = API_BASE_URL_ENV() + "/QRCode/valet";

export default class QrCodeValetService extends BaseService {
	constructor() {
		super(apiEndpoint);
	}
}
